import { STATE_ID, STATE_KEY } from './constants';

/**
 * A generator function that builds a setState hook for the given form.
 * @param formPrefixId
 * @param fields
 * @returns {(function(*): void)|*}
 */
export default function buildSetStateHook(formPrefixId, fields) {
	return function (state) {
		if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 1) {
			const stateField = fields.find(field => field.key === STATE_KEY);
			nfRadio.channel('fields').request('get:field', stateField.id).set('value', state)
				.trigger('field:change')
				.trigger('reRender');
		} else {
			nfRadio.channel('fields').request('get:field', formPrefixId + STATE_ID).set('value', state)
				.trigger('field:change')
				.trigger('reRender');
		}
	};
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/buildSetStateHook.js